/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentFirmwareFamily } from './equipment-firmware-family';
import { EquipmentModeSwitchOperationResponse } from './equipment-mode-switch-operation-response';
import { WorkersResponse } from './workers-response';
import { EquipmentModes } from './equipment-modes';
import { EquipmentSyntheticSleepOperationResponse } from './equipment-synthetic-sleep-operation-response';
import { EquipmentLocateOperationResponse } from './equipment-locate-operation-response';
import { DeviceFaultResponse } from './device-fault-response';


export interface EquipmentManagementInfoResponse { 
    modeId: number;
    serialNumber?: string | null;
    availableModes?: Array<EquipmentModes> | null;
    unavailableModes?: Array<EquipmentModes> | null;
    syntheticSleepActive?: boolean;
    firmwareFamily: EquipmentFirmwareFamily;
    locateActive?: boolean | null;
    modeSwitchOperation?: EquipmentModeSwitchOperationResponse;
    syntheticSleepOperation?: EquipmentSyntheticSleepOperationResponse;
    locateOperation?: EquipmentLocateOperationResponse;
    workers: Array<WorkersResponse>;
    faults?: Array<DeviceFaultResponse> | null;
    faultsCollectedAt?: string | null;
}



